import React, { useMemo } from "react";

import Label from "@busbud/design-system-components/dist/Label";
import Stack from "@busbud/design-system-components/dist/Stack";

import { AmenitiesChips } from "@app/components/amenities-chips";
import * as AmenitiesHelper from "@app/helpers/amenities";
import { useAppContext } from "@app/helpers/hooks";
import type { TripOption } from "@app/types/results-types";

interface Props {
  amenities: TripOption["amenities"];
}

export const SingleClassOption: React.FC<Props> = ({ amenities }) => {
  const { translator } = useAppContext();

  const amenity_keys = useMemo(() => {
    const supported_amenities = Array.isArray(amenities)
      ? amenities
      : AmenitiesHelper.filterSupportedAmenities(amenities);
    return AmenitiesHelper.getDisplayableAmenityKeys(supported_amenities);
  }, [amenities]);

  if (!amenity_keys.length) {
    return null;
  }

  return (
    <Stack spacing={1} direction="column">
      <Label size="lg" color="text.primary.opaque" fontWeight="bold">
        {translator.t("!results.departure.amenities.title")}
      </Label>
      <AmenitiesChips amenities={amenity_keys} />
    </Stack>
  );
};
